export const trackCreateAccountButtonClick = () => ({
    event: "select_register_option"
});

export const trackSignInButtonClick = () => ({
    event: "select_login_option"
});